import { Methods } from "@newview/infrastructure";
import {NewviewOaBaseApi} from "./NewviewOaBaseApi";


export class BiddingInfoV2Api extends NewviewOaBaseApi {

  public get ControllerName(): any {
    return 'bidding-info-v2'
  }

}